export const saas = {
  // Pricing page
  pricing: {
    title: 'Choose the plan that fits you',
    subtitle: 'Every plan starts with a 14-day trial. No commitment, cancel anytime.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlyDiscount: '-17%',
    free: 'Free',
    perMonth: 'Ft/mo',
    perYear: 'Ft/yr',
    plusVAT: '+ VAT',
    startFree: 'Start for free',
    startTrial: '14-day trial',
    startNow: 'Start now',
    notSure: 'Not sure? Try it free for 14 days.',
    popular: 'MOST POPULAR',
    popularBadge: 'Popular',
    unlimited: 'Unlimited',
    users: 'users',
    storage: 'GB storage',
    organizations: 'organizations',
    login: 'Sign In',
    loadingPackages: 'Loading packages...',
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'How long is the trial period?',
    faq1A: 'Every plan starts with a 14-day trial. All features are available during the trial, no credit card required.',
    faq2Q: 'Can I cancel my subscription anytime?',
    faq2A: 'Yes, you can cancel your subscription anytime in settings. The cancellation takes effect at the end of the current billing period.',
    faq3Q: 'Can I change plans later?',
    faq3A: 'Yes, you can upgrade or downgrade anytime. The difference is automatically prorated.',
  },
  
  // Onboarding wizard
  wizard: {
    // Steps
    stepOrganization: 'Organization',
    stepPackage: 'Plan',
    stepConfirmation: 'Confirmation',
    
    // Step 0: Organization
    orgTitle: 'Organization Details',
    orgSubtitle: 'Enter your organization\'s basic information. You can modify these later.',
    orgName: 'Organization Name',
    orgNameRequired: 'Organization name is required',
    orgNamePlaceholder: 'Acme Ltd.',
    taxNumber: 'Tax Number',
    taxNumberPlaceholder: '12345678-2-43',
    industry: 'Industry',
    industryPlaceholder: 'Select an industry',
    industryIt: 'IT / Technology',
    industryMarketing: 'Marketing / Advertising',
    industryConsulting: 'Consulting',
    industryTrade: 'Trade',
    industryManufacturing: 'Manufacturing',
    industryConstruction: 'Construction',
    industryServices: 'Services',
    industryHealthcare: 'Healthcare',
    industryEducation: 'Education',
    industryFinance: 'Finance',
    industryOther: 'Other',
    
    // Address
    addressTitle: 'Address',
    street: 'Street, Number',
    streetPlaceholder: '123 Main St.',
    city: 'City',
    cityPlaceholder: 'Budapest',
    postalCode: 'Postal Code',
    postalCodePlaceholder: '1000',
    country: 'Country',
    
    // Contact
    contactTitle: 'Contact Person',
    contactName: 'Name',
    contactNamePlaceholder: 'Full Name',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'email@example.com',
    contactPhone: 'Phone',
    contactPhonePlaceholder: '+36 30 123 4567',
    contactPosition: 'Position',
    contactPositionPlaceholder: 'CEO',
    
    // Step 1: Package
    packageTitle: 'Choose Your Plan',
    packageSubtitle: 'Select a plan. Every plan includes a 14-day trial period.',
    billingMonthly: 'Monthly',
    billingYearly: 'Yearly',
    billingYearlyNote: '(2 months free)',
    trialInfo: 'All features are available during the 14-day trial. After the trial, you can decide whether to switch to a paid plan.',
    
    // Step 2: Confirmation
    confirmTitle: 'Confirmation',
    confirmSubtitle: 'Review your details and confirm your registration.',
    confirmOrganization: 'Organization',
    confirmName: 'Name:',
    confirmIndustry: 'Industry:',
    confirmTaxNumber: 'Tax Number:',
    confirmPackage: 'Plan',
    confirmFreePackage: 'Free plan',
    confirmTrial: '14-day trial',
    confirmReady: 'Ready to get started!',
    confirmReadyDesc: 'After confirmation, you\'ll have immediate access to the system.',
    
    // Buttons
    back: 'Back',
    next: 'Next',
    createOrg: 'Create Organization',
    creating: 'Creating...',
    signOut: 'Sign Out',
    
    // Messages
    successMsg: 'Organization created successfully! Welcome to YouCRM!',
    errorMsg: 'Error creating organization',
    
    // Success screen
    successTitle: 'Everything is ready!',
    successSubtitle: 'Your organization has been created successfully. Click the button to get started.',
    startUsing: 'Start using',
  },
  
  // Payments / Subscriptions page
  payments: {
    total: 'Total',
    completed: 'Completed',
    pending: 'Pending',
    failed: 'Failed',
    revenue: 'Revenue',
    searchPlaceholder: 'Search by order number, customer or description...',
    allStatuses: 'All statuses',
    allTypes: 'All types',
    orderNumber: 'Order Number',
    customer: 'Customer',
    productService: 'Product/Service',
    type: 'Type',
    amount: 'Amount',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    noPayments: 'No payments to display',
    paid: 'Paid:',
    refund: 'Refund',
    // Status labels
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    statusCancelled: 'Cancelled',
    statusRefunded: 'Refunded',
    statusPartialRefund: 'Partial refund',
    // Purpose labels
    purposeSubscription: 'Subscription',
    purposeInvoice: 'Invoice',
    purposeProforma: 'Proforma',
    purposeTicketDeposit: 'Ticket deposit',
    purposeTicketService: 'Ticket service',
    purposeOther: 'Other',
    // Summary
    subscriptionsTitle: 'Subscriptions',
    invoicesTitle: 'Invoices',
    otherTitle: 'Other',
    active: 'active',
    paidCount: 'paid',
    successful: 'successful',
  },
  
  // Billing page
  billing: {
    newDocument: 'New document',
    invoiceDraft: 'Invoice draft',
    invoiceDraftDesc: 'Create a new invoice',
    proformaDraft: 'Proforma draft',
    proformaDraftDesc: 'Create a new proforma',
    receipt: 'Receipt',
    receiptDesc: 'Create a new receipt',
    receiptComingSoon: 'Receipt feature coming soon',
  },
  
  // Legal pages
  legal: {
    // Terms of Service
    termsTitle: 'Terms of Service',
    termsIntroTitle: 'Introduction',
    termsIntro: 'Welcome to YouCRM! These Terms of Service govern your use of our CRM system and the services we provide. By accessing or using the services, you agree to be bound by these terms.',
    termsAccessTitle: 'Access and Use',
    termsAccess: 'This system contains sensitive business information and is accessible only to authorized persons. Unauthorized access or use of the system is strictly prohibited.',
    termsAccountTitle: 'Account Security',
    termsAccount: 'You are responsible for maintaining the confidentiality of your account credentials. You are responsible for all activities that occur under your account.',
    termsPrivacyTitle: 'Privacy',
    termsPrivacy: 'We implement appropriate security measures to protect your data. You can find more information about our data handling practices in our Privacy Policy.',
    termsAvailabilityTitle: 'Service Availability',
    termsAvailability: 'We strive to provide continuous service, but we cannot guarantee that the service will always be available. We reserve the right to suspend or discontinue the service for maintenance or other reasons.',
    termsLiabilityTitle: 'Limitation of Liability',
    termsLiability: 'YouCRM shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from the use of or inability to use the service.',
    termsIntellectualTitle: 'Intellectual Property',
    termsIntellectual: 'YouCRM and its content, including software, design elements, trademarks, and copyrighted materials, are the exclusive property of WEBISSIMO Kft. Copying, modifying, or distributing these is prohibited.',
    termsTerminationTitle: 'Termination',
    termsTermination: 'You may cancel your subscription at any time. The cancellation remains active until the end of the current billing period. We reserve the right to immediately block access in case of violation of these terms.',
    termsPaymentTitle: 'Payment and Subscription',
    termsPayment: 'Subscription fees are charged in advance according to your selected plan. All prices do not include value-added tax (VAT), which is shown separately on the invoice.',
    termsGoverningTitle: 'Governing Law',
    termsGoverning: 'These Terms of Service are governed by Hungarian law. Any disputes arising shall be resolved under the jurisdiction of the Hungarian courts.',
    
    // Privacy Policy
    privacyTitle: 'Privacy Policy',
    privacyIntroTitle: 'Introduction',
    privacyIntro: 'YouCRM is committed to protecting your data. This Privacy Policy explains how we collect, use, and protect your data when you use our YouCRM system.',
    privacyCollectTitle: 'What Data We Collect',
    privacyCollect: 'We collect information that you provide directly to us, including personal data such as your name, email address, and other contact details. We also collect information about your customers, suppliers, and business partners that you enter into the system.',
    privacyUseTitle: 'How We Use Your Data',
    privacyUse: 'We use the information we collect to provide, maintain, and improve our services, develop new features, and protect our users. The system contains sensitive business information accessible only to authorized persons.',
    privacySecurityTitle: 'Data Security',
    privacySecurity: 'We implement appropriate security measures to protect your data from unauthorized access, modification, disclosure, or destruction. However, no method of internet transmission or electronic storage is 100% secure.',
    privacyRetentionTitle: 'Data Retention',
    privacyRetention: 'We retain your data for as long as your account is active or as necessary to provide the services. We retain and use your data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.',
    privacyRightsTitle: 'Your Rights',
    privacyRights: 'You have the right to access, correct, or delete your data. You may request data portability and object to data processing. To exercise your rights, please contact us.',
    privacyCookiesTitle: 'Cookies',
    privacyCookies: 'YouCRM uses cookies to operate the service and improve the user experience. Cookies are small text files stored by your browser. You can disable cookies in your browser settings.',
    privacyChangesTitle: 'Changes to the Privacy Policy',
    privacyChanges: 'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date.',
    
    // Company info
    companyTitle: 'Service Provider',
    companyName: 'WEBISSIMO Korlátolt Felelősségű Társaság',
    companyReg: 'Company registration number: 13-09-242688',
    companyTax: 'Tax number: 32894787-2-13',
    companyAddress: 'Registered office: 2161 Csomád, Szent István utca 48.',
    backToLogin: 'Back to sign in',
    fullDocsUrl: 'https://youcrm.hu/docs',
    viewFullDocs: 'View full document →',
  }
};
